import { useQuery, useMutation, useQueryClient } from 'react-query';
import UserService from 'services/userService';
import { AdminToolUserService } from '../services';
import { useAlerts } from './alerts-hooks';
import { useQueryParams } from './atoms/query-params-hook';

export function useUpdateUser(mutationOptions = {}) {
  const { alertSuccess, alertError } = useAlerts();
  const queryClient = useQueryClient();
  const { mutate, isLoading, data } = useMutation(
    (mutationParams) => {
      return AdminToolUserService.updateAdminToolUserDetails(mutationParams);
    },
    {
      onSuccess: () => {
        alertSuccess('User details successfully updated');
      },
      onError: (err) => {
        console.log(err);
        alertError('Error in updationg user details');
      },
      onSettled: () => {
        // Invalidate and refetch
        return queryClient.invalidateQueries([ 'user' ]);
      },
      ...mutationOptions,
    },
  );

  return {
    updateUser: mutate,
    updatedUser: data,
    userIsUpdating: isLoading,
  };
}

export function useGetUsers(queryOptions = {}) {
  const {
    page,
    setPage,
    limit,
    setLimit,
    sort,
    setSort,
  } = useQueryParams();

  const totalEntries = useQuery([ 'admin-tool-users-count' ], () => {
    return UserService.getTotalEntriesOfCollection();
  });

  const queryKey = [ 'admin-tool-users', { page, limit, sort }];
  const queryFn = () => {
    return UserService.get({ page, limit, setSort });
  };

  const q = useQuery({
    queryKey,
    queryFn,
    ...queryOptions,
  });
  return {
    users: q.data,
    usersLoading: q.isLoading,
    usersError: q.isError,
    count: totalEntries?.data,
    page,
    limit,
    setPage,
    setLimit,
    sort,
    setSort,
  };
}
